import { BsPersonCircle } from "react-icons/bs";
import { MdHome, MdMenu, MdChevronLeft, MdChevronRight } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import AuthenticateAPIs from "../../../MasonyFixingsAPIs/AuthenticateAPIs/AuthenticateAPIs";
import LogoNegOrange from "../../../Resources/Images/MF_Logo_NegOrange.png";
import './Header.css';

const Header = ({ setSidebarOpen, setCollapsed, collapsed }) => {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);

  const logout = () => {
    AuthenticateAPIs.GetLogout()
      .then((res) => {
        if (res.status === 200) navigate("/login");
      })
      .catch((err) => {
        if (err.response.status === 401 && err.response.data.logout) navigate("/login");
      });
  };

  return (
    <div className="app-header">
      <div className="header-left">
        {/* Burger menu (mobile only) */}
            <div className="burger mobile-only" onClick={() => setSidebarOpen(prev => !prev)}>
                <MdMenu />
            </div>

            {/* Logo */}
            <div className="logo" onClick={() => navigate("/")}>
                <img src={LogoNegOrange} alt="Logo" />
            </div>

            {/* Collapse toggle (desktop only) */}
            <div className="collapse-toggle desktop-only" onClick={() => setCollapsed(prev => !prev)}>
                {collapsed ? <MdChevronRight /> : <MdChevronLeft />}
            </div>
        </div>

      <div className="header-center">
        
      </div>

      <div className="header-right">
        <div className="profile" onClick={() => setShowMenu(!showMenu)}>
          <BsPersonCircle />
          <div className={`account-menu ${showMenu ? "active" : ""}`}>
            <div onClick={() => navigate("/my-account")}>My Account</div>
            <div onClick={() => logout()}>Logout</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;